import { VoiceDeployTarget } from 'shared/interfaces/Voice';

export enum VoiceCallStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  END_OF_CALL_HANDLED = 'END_OF_CALL_HANDLED'
}

export interface VoiceCallDuration {
  startedAt: Date;
  endedAt: Date;
  durationSeconds: number;
}

export interface LiveKitSessionInfo {
  roomName: string;
  egressId: string;
}

export interface VoiceCall {
  target: VoiceDeployTarget;
  status: VoiceCallStatus;
  liveKitSessionInfo: LiveKitSessionInfo;
  recordingUrl?: string;
  duration?: VoiceCallDuration;
  callerPhoneNumber?: string;
}
